module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/3_d44b43d1f8703c929a351a34a963dc09.png";